import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const cancelAdminSensorOrder = async (orderId) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}/cancel`,
    body: {},
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
